// convert '#RRGGBB' to 'rgba(r,g,b,opacity)'
export const hexToRgba = (hex, opacity = 1) => {
  const h = hex.replace('#', '');
  const r = parseInt(h.substring(0,2), 16);
  const g = parseInt(h.substring(2,4), 16);
  const b = parseInt(h.substring(4,6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
